export default __webpack_public_path__ + "static/media/architecture-img-10.b7c70440.jpg";